import { useQueryClient, useMutation } from "@tanstack/react-query";
import { restoreSurvey } from "./useRestoreSurvey.query";
import { useRestoreSurveyProps } from "./useRestoreSurvey.types";

export function useRestoreSurvey() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["survey_restore"],
        mutationFn: async (survey_id: useRestoreSurveyProps) => {
            const res = await restoreSurvey(survey_id);
            return res;
        },
        onSuccess: (_data, survey_id) => {
            queryClient.invalidateQueries({queryKey: ["surveys"]})
            queryClient.invalidateQueries({queryKey: ["survey", survey_id]})
        }
    });
}
